<template>
  <dr-wrapper v-if="isInEditorMode" v-bind="$props" v-on="wrapOn">
    <dr-formio-in-editor-wrapper v-if="formioIsLoaded" v-bind="$props" />
  </dr-wrapper>
  <div v-else>
    <dr-formio-in-viewer-mode-wrapper v-if="formioIsLoaded" v-on="wrapOn" v-bind="$props" />
  </div>
</template>

<script>
import { installFormio } from '../../formio'
import baseMixin from '../../mixins/base-mixin'
import widgetsWrapperMixin from '../../mixins/widgets-wrapper-mixin'
import inputMixin from '../../mixins/input-mixin'

export default {
  mixins: [baseMixin, inputMixin, widgetsWrapperMixin],
  components: {
    'dr-formio-in-editor-wrapper': () => import('./dr-formio-in-editor-mode-wrapper.vue'),
    'dr-formio-in-viewer-mode-wrapper': () => import('./dr-formio-in-viewer-mode-wrapper.vue')
  },
  data: () => ({
    formioIsLoaded: false
  }),
  async created() {
    await installFormio()
    this.formioIsLoaded = true
  }
}
</script>

<style>
.dr-formio-empty-form {
  width: 100%;
  height: 50px;
}
</style>
